module.exports = __webpack_public_path__ + "static/media/7-1-redcube.18d87051.png";